export default {"src":"/_next/static/media/0xf650c3d88d12db855b8bf7d11be6c55a4e07dcc9.802be270.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};